<template>
  <div class="relate-div" id="bulletin-list-new">
    <waterMark :num="60"></waterMark>
    <div class="relate-div">
      <!-- 展示变动信息 -->
      <div v-if="bulletinsType === 'transfer'">
        <el-table :data="bulletinData" size="small" style="width: 100%" class="no-bg" row-class-name="no-bg">
          <template slot="empty" >
            <span v-if="tabFrom == 'desk' && guanZhuIsNone" @click="changeDialog">您暂无订阅任何推送，点击<span class="bl-a-link">设置订阅</span>，选择您需要的职能模块和公司，系统将会推送对应的消息</span>
            <span v-else-if="tabFrom == 'desk' && !guanZhuIsNone" @click="changeDialog">暂无这些情报， 您也可以<span class="bl-a-link">修改订阅</span></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column prop="标题" label="标题" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="行业" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.行业 || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="公司" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.company" placement="top-start" :content="`公司:${scope.row.company.简称} 客户经理:${scope.row.company.客户开发}`">
                <span class="a-link" @click="clickCompany(scope.row.公司)">{{ scope.row.公司 }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.公司 || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="模块" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.模块 || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="变动因素" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.变动因素 || '--' }}
            </template>
          </el-table-column>
          <el-table-column
            prop="变动影响程度"
            label="变动影响程度"
            width="150"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="详情">
            <template slot-scope="scope">
              <el-tooltip placement="top-start">
                <pre style="width:500px;white-space:pre-line" slot="content">
标题: {{scope.row.标题 || '--'}}

详情: {{scope.row.详情}}</pre>
                <span class="a-link bl-tip-nowrap" @click="showDetail(scope.row, bulletinsType)">{{ scope.row.详情 || '--' }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="发布人" label="发布人" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="modifiedTimestamp" label="更新时间" width="150" :show-overflow-tooltip="true">
            <span slot-scope="scope">{{scope.row.modifiedTimestamp?getTime(scope.row.modifiedTimestamp*1000, 'yyyy-mm-dd HH:MM:ss'):'--'}}</span>
          </el-table-column>
          <el-table-column prop="跟进信息" label="跟进信息" width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" width="120">
            <!-- <template slot-scope="scope">
              <el-button type="text" size="mini" @click="showDetail(scope.row, bulletinsType)">详情</el-button>
              <el-button type="text" size="mini" @click="editBulletin(scope.row)">修改</el-button>
              <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
            </template> -->
            <template slot-scope="scope">
              <el-popover placement="right" width="150" trigger="click">
                  <div class="bulletinsTips">
                    <el-button
                      type="text"
                      size="mini"
                      @click="showDetail(scope.row, bulletinsType)"
                      >详情</el-button
                    >
                  </div>
                  <div v-if="scope.row.source != '圆手'" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="editBulletin(scope.row)">修改</el-button>
                  </div>
                  <div v-if="scope.row.source != '圆手'" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
                  </div>
                  <!-- <i slot="reference" class="el-icon-s-tools" style="font-size: 14px; color: rgb(64, 158, 255)"></i> -->
                  <el-button type="primary" size="mini" slot="reference">操作</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 展示招聘信息(官网，其他) -->
      <div v-else-if="bulletinsType === 'bd' && ['ofc', 'others'].indexOf(tabFrom) != -1">
        <el-card v-for="(item, k) in bulletinData" :key="k">
          <sup v-show="isNew(item.抓取日期)" class="el-badge__content el-badge__content--undefined is-dot"></sup>
          <el-row>
            <el-col :span="6">
              <div class="mgb-10">
                <span class="text-gray">公司：</span> <span>{{ item.公司 || '--' }}</span>
              </div>
              <div>
                <span class="text-gray">岗位名称：</span>

                <el-tooltip placement="right-start">
                  <pre style="width:500px;white-space:pre-line" slot="content">
岗位名称: {{item.标题 || '--'}}

岗位详情:
{{item.职位描述}}</pre>
                  <span class="a-link" @click="showDetail(item, bulletinsType, tabFrom)">{{ item.标题 || '--' }}</span>
                </el-tooltip>
              </div>
              <!-- <div>
                  <span class="text-gray">部门名称：</span> <span>{{ item.部门 || '--' }}</span>
                </div> -->
              <div style="margin-top: 10px">
                <span class="text-gray">圆手职能模块：</span>
                <span>{{ item.新圆手细分职能 && item.新圆手细分职能.join('，') || '--' }}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="mgb-10">
                <span class="text-gray">工作地点：</span> <span>{{ (item.城市 && item.城市.join(' ')) || '--' }}</span>
              </div>
              <div>
                <span class="text-gray">工作方式：</span> <span>{{ item.职位性质 || '--' }}</span>
              </div>
              <div style="margin-top: 10px">
                <span class="text-gray">系统职能模块：</span> <span>{{ item.模块 }}</span>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="mgb-10">
                <span class="text-gray">薪资范围：</span>
                <span v-if="item.月薪范围 && (item.月薪范围 instanceof String)" class="bull-content">{{  item.月薪范围 }}</span>
                <span v-else-if="item.月薪范围 && (item.月薪范围 instanceof Array)" class="bull-content">{{  item.月薪范围[0] }}-{{  item.月薪范围[1] }}</span>
                <span v-else>面议</span>
              </div>
              <div>
                <span class="text-gray">学历要求：</span> <span>{{ item.学历要求 || '--' }}</span>
              </div>
              <div v-if="item.level" style="margin-top: 10px">
                <span class="text-gray">职级：</span> <span>{{ item.职级 }}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="mgb-10">
                <span class="text-gray">招聘方式：</span> <span>{{ item.职位类别B || '--' }}</span>
              </div>
              <div>
                <span class="text-gray">工作年限：</span>
                <span>{{
                  item.工作经验 && item.工作经验.length == 2 ? `${item.工作经验[0]}-${item.工作经验[1]}年` : '不限'
                }}</span>
              </div>
            </el-col>
            <el-col :span="4">
              <div class="mgb-10">
                <span class="text-gray">发布日期：</span> <span>{{ getTime(item.createdAt) || '--' }}</span>
              </div>
              <div>
                <span class="text-gray">年龄要求：</span> <span>{{ item.年龄要求 || '不限' }}</span>
              </div>
            </el-col>
            <el-col :span="3">
              <div class="mgb-10">
                <span class="text-gray">截止日期：</span> <span>{{ item.end_time || '--' }}</span>
              </div>
              <div>
                <!-- <el-button type="primary" size="mini" @click="showDetail(item, bulletinsType, tabFrom)"
                  >查看详情</el-button
                >
                <el-button type="primary" size="mini" style="margin-left: 10px" @click="goto(item.url)"
                  >跳转官网</el-button
                > -->
                <el-button
                  type="primary"
                  size="mini"
                  @click="createItem(item)"


                >
                  一键建项
                </el-button>
                <span class="bl_blank"></span>
                <el-popover placement="right" width="150" trigger="click">
                  <div class="bulletinsTips">
                    <el-button type="text" size="mini" @click="showDetail(item, bulletinsType, tabFrom)"
                      >查看详情</el-button
                    >
                  </div>
                  <div class="bulletinsTips">
                    <el-button type="text" size="mini" @click="goto(item.url)"
                      >跳转官网</el-button
                    >
                  </div>

                  <!-- <i slot="reference" class="el-icon-s-tools" style="font-size: 14px; color: rgb(64, 158, 255)"></i> -->
                  <el-button type="primary" size="mini" slot="reference">操作</el-button>
              </el-popover>

              </div>
            </el-col>
          </el-row>
        </el-card>
      </div>
      <!-- 展示招聘信息(全部，推荐, 阿尔法) -->
      <div class="bulletins-list" v-else-if="bulletinsType === 'bd' && ['bull', 'desk', 'alpha'].indexOf(tabFrom) != -1">
        <el-table size="small" :data="bulletinData" style="width: 98%" class="no-bg"  row-class-name="no-bg">
          <template slot="empty">
            <span v-if="tabFrom == 'desk' && guanZhuIsNone" @click="changeDialog">您暂无订阅任何推送，点击<span class="bl-a-link">设置订阅</span>，选择您需要的职能模块和公司，系统将会推送对应的消息</span>
            <span v-else-if="tabFrom == 'desk' && !guanZhuIsNone" @click="changeDialog">暂无这些情报， 您也可以<span class="bl-a-link">修改订阅</span></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column type="index" :index="1"> </el-table-column>
          <el-table-column prop="公司" label="公司" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.company" placement="top-start" :content="`公司:${scope.row.company.简称} 客户经理:${scope.row.company.客户开发}`">
                <span class="a-link" @click="clickCompany(scope.row.公司)">{{ scope.row.公司 }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.公司 || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="岗位类型" width="150">
            <template slot-scope="scope">
              <div>
                <span v-if="['ofc', 'liepin'].indexOf(scope.row.来源) != -1">1-中端-非猎头职位</span>
                <span v-else>{{ scope.row.岗位类型 || '--' }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="行业" label="行业" width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="职能模块" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.模块 || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="岗位名称" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-tooltip placement="right-start">
                <pre slot="content" style="width:500px;white-space:pre-line">
岗位名称: {{scope.row.岗位名称 || scope.row.标题}}

岗位详情:
{{scope.row.岗位详情 || scope.row.职位描述}}</pre>
              <span
                class="a-link"
                v-if="scope.row.source == '圆手'"
                @click="showDetail(scope.row, bulletinsType, 'ofc')"
                >{{ scope.row.标题 }}</span
              >
              <span class="a-link" v-else @click="showDetail(scope.row, bulletinsType, 'alpha')">{{
                scope.row.岗位名称
              }}</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="跟进人" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              {{ scope.row.跟进人 || '--' }}
            </template>
          </el-table-column>
          <el-table-column label="发布人" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.来源 == 'ofc'">官网</span>
              <span v-if="scope.row.来源 == 'liepin'">猎聘</span>
              <span v-else>
                {{ scope.row.发布人 || '--' }}
              </span>
            </template>
          </el-table-column>
          <el-table-column label="发布时间" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.时间 || getTime(scope.row.updatedAt || scope.row.createdAt) || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="跟进信息" label="跟进信息" width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div>
                <el-button
                  type="primary"
                  size="mini"
                  @click="createItem(scope.row)"
                >
                  一键建项
                </el-button>
                <span class="bl_blank"></span>
                <el-popover placement="right" width="150" trigger="click">
                  <div class="bulletinsTips">
                    <el-button
                      type="text"
                      size="mini"
                      @click="showDetail(scope.row, bulletinsType, scope.row.source == '圆手' ? 'ofc' : 'alpha')"
                      >详情</el-button
                    >
                  </div>
                  <div v-if="scope.row.source != '圆手'" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="editBulletin(scope.row)">修改</el-button>
                  </div>
                  <div v-if="scope.row.source != '圆手'" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
                  </div>
                  <div v-if="scope.row.source != '圆手' && !scope.row.跟进人" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="genjinBulletin(scope.row)">我要跟进</el-button>
                  </div>
                  <!-- <i slot="reference" class="el-icon-s-tools" style="font-size: 14px; color: rgb(64, 158, 255)"></i> -->
                  <el-button type="primary" size="mini" slot="reference">操作</el-button>
                </el-popover>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 展示新闻信息 -->
      <!-- <div v-else-if="bulletinsType === 'others'"> -->
      <div v-if="bulletinsType === 'others'">
        <el-table
        v-if="bulletinsType === 'others' && ['bull', 'alpha', 'desk'].indexOf(tabFrom) != -1"
        :data="bulletinData"
        size="small"
        style="width: 100%"
        class="no-bg"
        row-class-name="no-bg"
        >
          <template slot="empty">
            <span v-if="tabFrom == 'desk' && guanZhuIsNone" @click="changeDialog">您暂无订阅任何推送，点击<span class="bl-a-link">设置订阅</span>，选择您需要的职能模块和公司，系统将会推送对应的消息</span>
            <span v-else-if="tabFrom == 'desk' && !guanZhuIsNone" @click="changeDialog">暂无这些情报， 您也可以<span class="bl-a-link">修改订阅</span></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="标题" width="200" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.标题 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容" :show-overflow-tooltip="true" width="750">
            <template slot-scope="scope">
              <span v-if="scope.row.来源 == '百度'" class="bl-a-link" @click="goto(scope.row.url)">
                {{ scope.row.简介 }}
              </span>
              <span v-else class="bl-a-link" @click="showDetail(scope.row, bulletinsType, scope.row.source == '圆手' ? 'ofc' : 'alpha')">{{ scope.row.内容 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布人" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.来源 == '百度'"> 百度 </span>
              <span v-else>{{ scope.row.发布人 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span v-if="scope.row.来源 == '百度'">
                {{ scope.row.发布时间 && scope.row.发布时间.replace(/:/gi, '-') }}
              </span>
              <span v-else>{{scope.row.modifiedTimestamp?getTime(scope.row.modifiedTimestamp*1000, 'yyyy-mm-dd HH:MM:ss'):'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="跟进信息" label="跟进信息" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <div v-if="!scope.row.url">
                <el-popover placement="right" width="150" trigger="click">
                  <div v-if="!scope.row.url" class="bulletinsTips">
                    <el-button
                      type="text"
                      size="mini"
                      @click="showDetail(scope.row, bulletinsType)"
                      >详情</el-button
                    >
                  </div>
                  <div v-if="!scope.row.url" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="editBulletin(scope.row)">修改</el-button>
                  </div>
                  <div v-if="!scope.row.url" class="bulletinsTips">
                    <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
                  </div>
                  <!-- <i slot="reference" class="el-icon-s-tools" style="font-size: 14px; color: rgb(64, 158, 255)"></i> -->
                  <el-button slot="reference" type="primary" size="mini">操作</el-button>
                </el-popover>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 百度新闻页 -->
        <el-table
          v-else-if="bulletinsType === 'others' && tabFrom == 'baidu'"
          :data="bulletinData"
          size="small"
          style="width: 100%"
          class="no-bg"
          row-class-name="no-bg"
        >
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="公司" width="100" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.简称 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="标题" width="200" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.标题 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容" width="750">
            <template slot-scope="scope">
              <span class="bl-a-link" @click="goto(scope.row.url)">{{ scope.row.简介 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="来源" width="150">
            <template slot-scope="scope">
              <span v-if="scope">百度</span>
            </template>
          </el-table-column>
          <el-table-column label="时间" width="150">
            <template slot-scope="scope">
              <span> {{ scope.row.发布时间 && scope.row.发布时间.replace(/:/gi, '-') }} </span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 展示融资信息 -->
      <div v-if="bulletinsType === 'financing'">
        <el-table
          :data="bulletinData"
          size="small"
          style="width: 100%"
          class="no-bg"
          row-class-name="no-bg"
        >
          <template slot="empty">
            <span v-if="tabFrom == 'desk' && guanZhuIsNone" @click="changeDialog">您暂无订阅任何推送，点击<span class="bl-a-link">设置订阅</span>，选择您需要的职能模块和公司，系统将会推送对应的消息</span>
            <span v-else-if="tabFrom == 'desk' && !guanZhuIsNone" @click="changeDialog">暂无这些情报， 您也可以<span class="bl-a-link">修改订阅</span></span>
            <span v-else>暂无数据</span>
          </template>
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column label="标题" width="200" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{ scope.row.标题 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="公司" width="140" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <el-tooltip v-if="scope.row.company" placement="top-start" :content="`公司:${scope.row.company.简称} 客户经理:${scope.row.company.客户开发}`">
                <span class="a-link" @click="clickCompany(scope.row.公司)">{{ scope.row.公司 }}</span>
              </el-tooltip>
              <span v-else>{{ scope.row.公司 || '--' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="疑似联系方式" :show-overflow-tooltip="true" width="160">
            <template slot-scope="scope">
              <span>{{ scope.row.疑似联系方式 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="内容" :show-overflow-tooltip="true" width="600">
            <template slot-scope="scope">
              <span class="bl-a-link" @click="showDetail(scope.row, bulletinsType, 'alpha')">{{ scope.row.内容 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="发布人" width="100">
            <template slot-scope="scope">
              <span>{{ scope.row.发布人 }}</span>
            </template>
          </el-table-column>
          <el-table-column label="更新时间" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <span>{{scope.row.modifiedTimestamp?getTime(scope.row.modifiedTimestamp*1000, 'yyyy-mm-dd HH:MM:ss'):'--'}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="跟进信息" label="跟进信息" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-popover placement="right" width="150" trigger="click">
                <div class="bulletinsTips">
                  <el-button
                    type="text"
                    size="mini"
                    @click="showDetail(scope.row, bulletinsType)"
                    >详情</el-button
                  >
                </div>
                <div class="bulletinsTips">
                  <el-button type="text" size="mini" @click="editBulletin(scope.row)">修改</el-button>
                </div>
                <div class="bulletinsTips">
                  <el-button type="text" size="mini" @click="delBulletin(scope.row)">删除</el-button>
                </div>
                <!-- <i slot="reference" class="el-icon-s-tools" style="font-size: 14px; color: rgb(64, 158, 255)"></i> -->
                <el-button slot="reference" type="primary" size="mini">操作</el-button>
              </el-popover>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
    <editDialog ref="editDialog"></editDialog>
    <bulletinDetail ref="bulletinDetail"></bulletinDetail>
  </div>
</template>
<script>
import bulletinDetail from './bulletinDetail'
import editDialog from './editDialog'
const dateFormat = require('dateformat')
export default {
  data(){
    return {
      dialogVisible: false
    }
  },
  components: { bulletinDetail, editDialog },
  props: {
    guanZhuIsNone: {
      type: Boolean,
      default: false
    },
    tabFrom: {
      type: String,
      default: 'desk',
    },
    bulletinsType: {
      type: String,
      default: 'transfer',
    },
    bulletinData: {
      type: Array,
      default: [],
    },
    handleEdit: {
      type: Function,
      default: () => {},
    },
  },
  mounted(){
    let bulletinDetail = localStorage.getItem('bulletinDetail')
    if (bulletinDetail) {
      bulletinDetail = JSON.parse(bulletinDetail)
      this.showDetail(bulletinDetail.item, bulletinDetail.bulletinType, bulletinDetail.tabFrom)
      localStorage.removeItem('bulletinDetail')
    }
  },
  methods: {
    changeDialog(){
      // 打开修改关注
      this.$refs.editDialog.dialogVisible = true
    },
    closeDialog(){
      // 关闭修改关注
      this.dialogVisible = false
      // 父组件更新数据
      this.$emit('loadData')

    },
    handleClickDetail(row, column, event) {
      if (row.url) this.goto(row.url)
      else this.showDetail(row, this.bulletinsType, this.tabFrom)
    },
    isNew(time) {
      if (!time) return false
      const ago7 = dateFormat(new Date(new Date().getTime() - 7 * 24 * 3600000), 'yyyy-mm-dd')
      return time > ago7
    },
    getTime(time, format) {
      return time ? dateFormat(time, format || 'yyyy-mm-dd') : ''
    },
    editBulletin: async function (row) {
      this.formData = Object.assign({}, row)
      const cate = this.formData['模块']
      if (cate && typeof cate === 'string') this.formData['模块'] = this.formData['模块'].split(',')
      this.handleEdit(this.formData)
    },
    delBulletin: function (row) {
      this.$confirm('确定删除该情报吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const res = await app.service('misc').deleteBulletin({ _id: row._id })
          if (res.status === 'success') {
            this.$message.success('删除成功')
            this.bulletinData = this.bulletinData.filter((bull) => bull._id !== row._id)
          } else {
            this.$message.error(res.msg)
          }
        })
        .catch(() => {})
    },
    genjinBulletin: async function (row) {
      const res = await app.service('misc').modifyBulletin({
        _id: row._id,
        data: { 跟进人: app.user.account },
      })
      if (res.status === 'success') {
        this.$message.success('操作成功')
        this.bulletinData = this.bulletinData.map(bull => {
          if (bull._id === row._id) {
            bull.跟进人 = app.user.account
          }
          return bull
        })
      } else {
        this.$message.error(res.msg)
      }
    },
    showDetail: async function (row, bulletinType, tabFrom) {
      this.$refs.bulletinDetail.show(row, bulletinType, tabFrom)
    },
    goto(url) {
      if (!url) return this.$message('无官网链接')
      window.open(url)
    },

    async searchJobName(name) {
      const res = await app.service('project').getRecommendJobNameAndCate({ keyword: name })
      if (res.status !== 'success') return []
      const { 推荐职能模块: cates = {}, 职位: jobs = [] } = res.data
      return cates
    },
    async createItem(item){
      let cate = item.模块 || ''
      debugger
      if (!cate) {
        let res = await this.searchJobName(item.岗位名称 || item.标题)
        if (res) {
          for (let i in res) {
            if (res[i] && res[i].length > 0) {
              cate = res[i][0]
              break
            }
          }
        }
      }
      this.goto(`#/createProject20?cmp=${item.公司}&kehu=${item.发布人 || ''}&job=${item.岗位名称 || item.标题}&detail=${item.职位描述|| item.岗位详情|| ''}&cate=${cate}`)
    },
    clickCompany: function(companyName) {
      app.root.onPull()
      app.root.$refs.drawer.search({
        type: '公司',
        keywords: companyName,
      })
    },
  },
}
</script>
<style>
.bulletinList-list {
  padding: 0 40px;
}
#bulletin-list-new tr.hover-row>td {
  background-color: #92bed44d;
  /* background-color: #fff; */
}
.bulletinList-alpha .el-card {
  margin-bottom: 2px;
}
#bulletin-list-new .el-table__body tr:hover>td {
  background-color: #92bed44d;
}
</style>
<style scoped>
.bl-tip-nowrap {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.text-gray {
  color: grey;
}
.bulletinsTips {
  width: 100%;
  text-align: center;
}
.bl_blank {
  display: inline-block;
  width: 10px;
}
.bl_opt {
  padding-left: 40px;
}
.bl-others span {
  line-height: 35px;
}
.bl-a-link {
  color: #0472c7;
  white-space:nowrap;/* 规定文本是否折行 */
  overflow: hidden;/* 规定超出内容宽度的元素隐藏 */
  text-overflow: ellipsis;
}
</style>
